module.exports = __webpack_public_path__ + "img/locations.0270e083.jpg";